<template>
  <div id="basic-master">
    <vs-row v-if="!isEditingOrder" vs-type="flex" vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
        <p class="aisea-text-14-700-black" style="white-space:nowrap;">検索</p>
        <vs-input
          class="search-input aisea-text-14-400-gray"
          :style="{ width: getDeviceInfo().deviceType === 'iPhone' ? '100%' : null } "
          v-model="searchInput"
          placeholder="キーワードを入力"
          @keydown.enter="searchInputEnter"
        >
        </vs-input>
      </vs-col>

      <!--仕様固まり次第コメントアウト解除 <vs-button
                class="order-button top-button border-button"
                color="#ffffff"
                v-if="summaryPageName"
                :to="{ name: summaryPageName }"
              >
                <div class="button-inner">
                  <feather-icon
                    class="mr-2"
                    icon="ListIcon"
                    svgClasses="h-5 w-5"
                  />
                  <span>コンテナ稼働状況</span>
                </div>
              </vs-button>
              <div v-else class="add-button blank"></div> -->

      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-lg="8"
        vs-sm="8"
        vs-xs="12"
      >
        <vs-button
          class="action-button"
          color="#2D9CDB"
          :to="{ name: insertDataPageName }"
        >
          <div class="aisea-text-14-400-white button-inner">
            <feather-icon class="mr-2" icon="PlusIcon" svgClasses="h-5 w-5" />
            <span>新規登録</span>
          </div>
        </vs-button>

        <vs-button
          class="action-button border-button"
          color="#ffffff"
          @click="clickChangeOrder"
          v-if="sortable"
        >
          <div class="aisea-text-14-400-blue button-inner">
            <feather-icon class="mr-2" icon="ListIcon" svgClasses="h-5 w-5" />
            <span>表示順序変更</span>
          </div>
        </vs-button>
      </vs-col>
    </vs-row>

    <vs-row v-else>
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-lg="8"
        vs-sm="4"
        vs-xs="12"
      >
        <span class="aisea-text-14-400-black title">表示順序変更</span>
      </vs-col>

      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="center"
        vs-lg="4"
        vs-sm="8"
        vs-xs="12"
      >
        <vs-button
          class="aisea-text-14-400-white action-button"
          @click="cancelEditOrder"
          color="#BDBDBD"
        >
          <div class="button-inner">
            <span>キャンセル</span>
          </div>
        </vs-button>
        <vs-button
          class="aisea-text-14-400-white action-button"
          color="#2D9CDB"
          @click="callUpdateOrder"
        >
          <div class="button-inner">
            <span>保存</span>
          </div>
        </vs-button>
      </vs-col>
    </vs-row>

    <div class="table-area vx-card" >
      <div class="lg-view">
        <vs-row class="header row" vs-type="flex" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="1"
            vs-sm="1"
            vs-xs="3"
          ></vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="3"
            >顧客企業名</vs-col
          >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="3"
            >担当者</vs-col
          >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="3"
            >電話番号</vs-col
          >
        </vs-row>
      </div>
      <draggable
        v-model="filteredData"
        :disabled="!isEditingOrder"
        @start="drag = true"
        @end="drag = false"
        v-bind="dragOptions"
      >
        <div v-for="(rowData, index) in filteredData" :key="rowData.id">
          <vs-row class="row aisea-text-14-400-black" vs-type="flex" vs-w="12">
            <vs-col
              class="lg-view"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-lg="1"
              vs-sm="1"
              vs-xs="3"
            >
              <span class="cell index"
                :class="{ clickable: !isEditingOrder }"
                style="width: 100%;"
                @click="clickRow(rowData.id)"
              >
                
                  {{
                    pagination && !isEditingOrder
                      ? indexFrom + index
                      : index + 1
                  }}
              </span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
              class="customer-col-data"
            >
              <span class="customer-name" 
                style="width: 100%;"
                @click="clickRow(rowData.id)">{{ rowData.name }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-lg="3"
              vs-sm="3"
              vs-xs="4"
              class="customer-col-data"
            >
              <span style="width: 100%;"
                @click="clickRow(rowData.id)">
                {{ rowData.person_in_charge }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-lg="3"
              vs-sm="3"
              vs-xs="5"
              class="customer-col-data"
            >
              <span style="width: 100%;"
                @click="clickRow(rowData.id)">
                {{ rowData.tel }}</span>
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
              vs-lg="1"
              vs-sm="1"
              vs-xs="3"
              style="flex:auto;"
            >
              <div class="flex items-center" style="position: relative; height: 100%;">
                <vs-dropdown
                  color="#2D9CDB"
                  :vs-trigger-click="true"
                  v-if="!isEditingOrder"
                >
                  <feather-icon
                    class="mr-2"
                    icon="MoreVerticalIcon"
                    svgClasses="h-5 w-5"
                  />
                  <vs-dropdown-menu class="more-button-dropdown">
                    <vs-dropdown-item @click="openDeletePopup(rowData)">
                      <span class="flex items-center">
                        <feather-icon
                          icon="TrashIcon"
                          svgClasses="h-4 w-4"
                          class="mr-2"
                          :style="{ color: AISEA_COLOR.BLUE }"
                        />
                        <span class="aisea-text-14-400-blue" style="margin-left:auto; margin-right:auto;" >削除</span>
                      </span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </draggable>
    </div>

    <vs-popup
      class="basic-master-popup aisea-text-14-400-black"
      :title="masterName + 'の削除'"
      :active.sync="popupActive"
    >
      <p>「{{ deleteTarget.displayName }}」を削除してよろしいですか？</p>
      <div class="button-area">
        <vs-button
          class="aisea-text-14-400-white popup-button"
          color="#BDBDBD"
          @click="closeDeletePopup"
          >キャンセル</vs-button
        >
        <vs-button
          class="aisea-text-14-400-white popup-button"
          color="#2D9CDB"
          @click="callDelete(deleteTarget.id)"
          >削除</vs-button
        >
      </div>
    </vs-popup>
    <error-dialog ref="errorDialog"></error-dialog>
  </div>
</template>

<script>
import ErrorDialog from "../components/ErrorDialog";
import draggable from "vuedraggable";
import _ from "lodash";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  components: {
    draggable,
    ErrorDialog,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    data: { type: Array },
    columns: { type: Array },
    masterName: { type: String },
    colorOptions: { type: Array },
    insertDataPageName: { type: String },
    summaryPageName: { type: String },
    selectOptions: { type: Object },
    pagination: { type: Boolean, default: false },
    totalPages: { type: Number },
    totalItems: { type: Number },
    currentPage: { type: Number },
    incrementSearch: { type: Boolean, default: true },
    sortable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    viewPageName: { type: String },
    displayItems: { type: Object },
    storedSearchKeyword: { type: String, default: "" },
  },
  data() {
    return {
      drag: false,
      searchInput: this.storedSearchKeyword,
      isEditingId: "",
      isEditingOrder: false,
      inputData: [],
      receivedData: [],
      filteredData: [],
      popupActive: false,
      currentPageTemp: this.currentPage + 1,
      isForcedChangeCurrentPage: false,
      deleteTarget: {
        id: "",
        displayName: "",
      },
      displayItemsOptions: [
        {
          number: 10,
        },
        {
          number: 20,
        },
        {
          number: 30,
        },
      ],
      displayItemsTemp: this.displayItems,
    };
  },
  watch: {
    data(value) {
      this.receivedData = JSON.parse(JSON.stringify(value));
      this.inputData = JSON.parse(JSON.stringify(value));
      this.filteredData = JSON.parse(JSON.stringify(value));
    },
    searchInput() {
      if (this.incrementSearch) {
        this.callSearch();
      }
    },
    currentPageTemp(value) {
      if (!this.isForcedChangeCurrentPage) {
        let searchCondition = {
          limit: this.displayItems.number,
          page: value - 1,
        };
        this.$emit("callSearch", searchCondition);
      }
    },
    displayItemsTemp: {
      handler() {
        this.$emit("updateDisplayItems", this.displayItemsTemp);
        let searchCondition = {
          limit: this.displayItemsTemp.number,
          page: 0,
        };
        this.isForcedChangeCurrentPage = true;
        this.currentPageTemp = 1;
        this.isForcedChangeCurrentPage = false;

        this.$emit("callSearch", searchCondition);
      },
      deep: true,
    },
  },
  computed: {
    displayItemsText() {
      let from =
        this.receivedData.length != 0
          ? this.currentPage * this.displayItemsTemp.number + 1
          : 0;
      let to =
        this.currentPage * this.displayItemsTemp.number +
        this.receivedData.length;
      let total = this.totalItems;
      return `${from}-${to}/${total}`;
    },
    indexFrom() {
      return this.receivedData.length != 0
        ? this.currentPage * this.displayItemsTemp.number + 1
        : 0;
    },
    dataChanged() {
      return !_.isEqual(this.receivedData, this.inputData);
    },
    searchKeys() {
      return this.columns
        .filter((column) => column.searchable)
        .map((filteredColumns) => filteredColumns.key);
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    callSearch() {
      if (this.incrementSearch) {
        this.isEditingId = "";
        this.filteredData = this.receivedData.filter((element) => {
          return this.searchKeys.some((key) =>
            element[key] ? element[key].includes(this.searchInput) : false
          );
        });
      } else {
        let searchCondition = {
          keyword: this.searchInput,
          limit: this.displayItems.number,
          page: 0,
        };
        this.isForcedChangeCurrentPage = true;
        this.currentPageTemp = 1;
        this.isForcedChangeCurrentPage = false;

        this.$emit("callSearch", searchCondition);
      }
    },
    searchInputEnter(event) {
      if (event.keyCode !== 13 || this.incrementSearch) return;
      this.callSearch();
    },
    clickRow(id) {
      if (this.isEditingOrder) return;
      if (this.editable) {
        this.isEditingId = id;
      } else {
        this.toViewPage(id);
      }
    },
    callSave() {
      let editedRowData = this.inputData[
        this.inputData.findIndex((element) => element.id == this.isEditingId)
      ];
      this.$emit("callSave", editedRowData);
      this.isEditingId = "";
    },
    callDelete(id) {
      if (this.pagination) {
        this.isForcedChangeCurrentPage = true;
        this.currentPageTemp = 1;
        this.isForcedChangeCurrentPage = false;
      }
      this.popupActive = false;
      this.$emit("callDelete", id);
    },
    callUpdateOrder() {
      this.isEditingOrder = false;
      let sortOrders = this.filteredData.map((rowData, index) => {
        return {
          id: rowData.id,
          sort_order: index,
        };
      });
      this.$emit("callUpdateOrder", sortOrders);
    },
    forceUpdateTable(value) {
      this.searchInput = "";
      this.filteredData = value;
      this.inputData = JSON.parse(JSON.stringify(this.filteredData));
    },
    cancelEdit() {
      this.isEditingId = "";
      this.inputData = JSON.parse(JSON.stringify(this.filteredData));
    },
    cancelEditOrder() {
      if (!this.pagination) {
        this.isEditingOrder = "";
        this.filteredData = this.receivedData;
      } else {
        this.isEditingOrder = "";
        this.callSearch();
      }
    },
    updateValue(index, key, value) {
      this.inputData[index][key] = value;
    },
    clickChangeOrder() {
      if (!this.pagination) {
        this.isEditingOrder = true;
        this.isEditingId = "";
        this.searchInput = "";
        this.filteredData = this.receivedData;
      } else {
        this.isEditingOrder = true;
        this.$emit("callFetchAll");
      }
    },
    openDeletePopup(rowData) {
      this.deleteTarget = {
        id: rowData.id,
        displayName: rowData[this.columns[0].key],
      };
      this.popupActive = true;
    },
    openErrorPopup(title, errorMessage, validationErrors) {
      this.$refs.errorDialog.open(title, errorMessage, validationErrors);
    },
    closeDeletePopup() {
      this.popupActive = false;
    },
    toViewPage(id) {
      if (!this.editable) {
        this.$router.push({
          name: this.viewPageName,
          params: { itemId: id },
        });
      }
    },
    generateClassses(columnData) {
      let classObj = {};
      classObj[columnData.key] = true;
      if (Object.prototype.hasOwnProperty.call(columnData, "cellClass")){
        classObj[columnData.cellClass] = true;
      }
      return classObj;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@media (max-width: 576px) {
  .xs-view {
    display: inline !important;
  }
  .lg-view {
    display: none !important;
  }
}
@media (min-width: 575px) {
  .xs-view {
    display: none !important;
  }
  .lg-view {
    display: inline !important;
  }
}
#basic-master {
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.1;
    background: $aisea-blue;
  }
  .title {
    font-size: 18px;
  }
  .upper-controller {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }
  .display-items-select-box {
    margin-left: 10px;
    width: 145px;
    .vs__search {
      padding: 0px;
    }
  }
  .display-items {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .action-button {
    margin: 0 0 0.6rem 0.4rem;
    height: 2.9rem;
  }
  .top-button {
    height: 42px;
  }
  .border-button {
    border: solid 1px $aisea-blue;
    box-sizing: border-box;
    .button-inner {
      color: $aisea-blue;
    }
  }
  .button-inner {
    display: flex;
    align-items: center;
  }
  .search-input {
    height: 42px;
    margin: 15px 0 10px 10px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 53px;
    height: fit-content;
    display: flex;
    padding: 0.6rem 0;
    border-bottom: solid 1px $aisea-light-gray;
  }
  .content-row {
    justify-content: space-between;
    transition: 0.3s;
    flex-wrap: wrap;
    position: relative;
    &:hover {
      background: $aisea-white;
    }
  }
  .main-columns {
    display: flex;
    flex-grow: 1;
  }
  .cell {
    display: flex;
    margin-right: 10px;
    padding: 5px 10px;
    align-items: center;
    &.name {
      min-width: 170px;
      max-width: 170px;
    }
    &.person_in_charge {
      min-width: 170px;
      max-width: 170px;
    }
    &.tel {
      min-width: 170px;
      max-width: 170px;
    }
    &.description {
      max-width: 1000px;
    }
    &.function {
      margin-left: 30px;
      margin-right: 0px;
    }
    &.index {
      font-weight: bold;
      min-width: 40px;
      max-width: 40px;
      margin-right: 0px;
      // margin-top: 10px;
    }
  }
  .row.focused {
    background: $aisea-white;
  }
  .main-columns.clickable {
    cursor: pointer;
  }
  .row.ordered:hover {
    cursor: grab !important;
  }
  .row.dragged:hover {
    cursor: move;
  }
  .control-button {
    margin-right: 10px;
    white-space: nowrap;
  }

  .master-pagination {
    margin-top: 20px;
  }

  .more-button:hover {
    cursor: pointer;
  }

  .table-area {
    padding: 10px;
  }
  .customer-col-data {
    padding: 0.2rem 0.3rem;
    min-height: 26px;
  }

}
.basic-master-popup {
  .popup-button {
    margin-left: 10px;
  }
  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
}
.more-button-dropdown {
  width: 90px;
}
.customer-name {
  width: calc(100%);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vs-input--placeholder {
  font-size: 14px;
  font-family: $aisea-font-family;
  font-weight: 400;
  color: $aisea-gray;

}
.vs-dropdown--menu {
  padding: 0.6rem;
  width: 8rem;
}
.vs-dropdown--menu--after {
  // 吹き出し三角を消す
  width: 0px;
  height: 0px;
}
</style>
